import { render } from "./IconThumbUpOutline.vue?vue&type=template&id=da1ea39e"
import script from "./IconThumbUpOutline.vue?vue&type=script&lang=js"
export * from "./IconThumbUpOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__